export enum ContentType {
	CKEditor = "CKEditor",
	Quotation = "Quotation",
	UnorderedList = "UnorderedList",
	LeadParagraph = "LeadParagraph",
}
